import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Resources/Resources.css';
import { db } from '../../../src/service/firebaseconfig';
import { collection, getDocs } from 'firebase/firestore';
import LoaderSVG from "../Loader/LoaderSVG";

function Eventpage() {
  const [eventdata, setEventdata] = useState([]);
  const [spinner, setSpinner] = useState(false)
  const navigate = useNavigate();

  // Firestore reference
  const EventdataRef = collection(db, "Event Details");

  const getEventDetails = async () => {
    setSpinner(true)
    try {
      const Eventdoc = await getDocs(EventdataRef);
      const filteredData = Eventdoc.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setEventdata(filteredData);
    } catch (err) {
      console.error(err);
    } finally {
      setSpinner(false)
    }
  };

  useEffect(() => {
    getEventDetails();
  }, []);

  const eventpage = (eventId) => {
    navigate(`/Events/${eventId}`);
  };

  return (
    <section>
      <>{spinner ? <LoaderSVG/> : (<div className="EVENTS">
        {eventdata.map((event, index) => (
          <div className="EVENTS-item" key={index}>
            <span className='SPAN_EVENTS'><img src={event.Image} alt={`Gallery image for ${event.Event_Name}`} className="photo"/></span>
            <div className="content">
              <h2 className="title">{event.Event_Name}</h2>
              <p className="description">{event.B_Description}<a className="view-more" onClick={() => eventpage(event.id)}>view more</a > </p>
            </div>
          </div>
        ))}
      </div>)}
      </>
    </section>
  );
}

export default Eventpage;

